module.exports = "../dist/frontend/icons/benefits/green/message.svg?0d59484137e2787d5d8f27229616ab6e";